// Version 0.1.5 API verified against its npm README and .d.ts files.
// Keep this import build-time resolvable: never load scanner code from a CDN.
export async function loadZXing() {
  const { BrowserMultiFormatReader } = await import("@zxing/browser");
  return new BrowserMultiFormatReader();
}
